<bit-dialog
  dialogSize="default"
  background="default"
  class="bv-confirm-dialog bv-add-extension-later-dialog"
>
  <span bitDialogTitle class="tw-sr-only">{{
    "cannotAutofillPasswordsWithoutExtensionTitle" | i18n
  }}</span>
  <div bitDialogContent class="bv-confirm-dialog__content">
    <div class="bv-confirm-dialog__icon" aria-hidden="true"></div>
    <h2 class="bv-confirm-dialog__title">
      {{ "cannotAutofillPasswordsWithoutExtensionTitle" | i18n }}
    </h2>
    <p class="bv-confirm-dialog__message">
      {{ "cannotAutofillPasswordsWithoutExtensionDesc" | i18n }}
    </p>
  </div>
  <ng-container bitDialogFooter>
    <div class="bv-confirm-dialog__footer">
      <a
        bitButton
        buttonType="primary"
        [href]="webStoreUrl"
        target="_blank"
        rel="noopener noreferrer"
      >
        {{ "getTheExtension" | i18n }}
      </a>
      <a
        bitButton
        buttonType="secondary"
        routerLink="/vault"
        bitDialogClose
        (click)="dismissExtensionPage()"
      >
        {{ "skipToWebApp" | i18n }}
      </a>
    </div>
  </ng-container>
</bit-dialog>
